
export default {
    // i18n of Sidebar.vue
    "Photos": "照片",
    "My Albums": "我的相簿",
    "sidebar.photo_library": "图库",
    "sidebar.recent": "最近项目",
    "sidebar.favorites": "个人收藏",
    "People": "人物",
    "sidebar.people.title": "人物{0}",
    "sidebar.shared_album": "共享的相册",

    // i18n of Content.vue
    "content.photo_count": "{0}张图片",
    "content.ctx_menu.zoom_in": "放大",
    "content.ctx_menu.zoom_out": "缩小",
    "content.ctx_menu.default_scale": "默认缩放 (当前: {0})",
    "content.ctx_menu.share": "分享...",
    "content.ctx_menu.export_fav": "导出个人收藏",
    "content.ctx_menu.import_fav": "导入个人收藏",

    "content.share_dialog.title": "分享相册",
    "content.share_dialog.sharing": "共享相册：",
    "content.share_dialog.set_password_label": "设置分享密码：",
    "content.share_dialog.share_btn": "分享",
    "content.share_dialog.share_link_is": "分享链接为：",
    "content.share_dialog.share_link_desc_1": "将这个链接发送给其他人即可分享该相册，无需将相册的访问密码提供给对方。\n获得该分享链接的人需要输入分享密码方可查看。",
    "content.share_dialog.share_link_desc_2": "如果想要取消对方的访问权限，请使用项目提供的工具重新生成分享API。",
    "content.share_dialog.unsharable": "不能分享该相册。",

    "content.fav.unsupported": "你的浏览器不支持Local Storage，无法使用此功能。",
    "content.fav.unrecognized": "选择的文件无法识别！",

    // i18n of PopupDialog.vue
    "popup.complete_btn": "完成",

    // i18n of PasswordInput.vue
    "pwdi.title": "相册",
    "pwdi.hint": "请输入密码以访问相册。",
    "pwdi.retry": "密码错误，请重新输入！",
    "Password": "密码",
    "OK": "确定",

    // i18n of Preview.vue
    "preview.loading": "正在加载图片...",
    "preview.download_btn": "下载",
    "preview.zoom_in": "放大",
    "preview.zoom_out": "缩小",
    "preview.zoom_percent": "缩放百分比",
    "preview.reset_zoom": "重置",
    "preview.prev_photo": "上一张（左方向键）",
    "preview.next_photo": "下一张（右方向键）",
    "Album": "相册",

    // i18n of Settings.vue
    "Settings": "设置",
    "General": "通用",
    "Language": "语言",
    "About": "关于",
    "Close": "关闭",
    "settings.language_hint": "修改语言后会自动刷新页面。",
    "settings.license": "Licensed: MIT License",
}